import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ServiceDetailModel } from '../../models/service-detail-model';
import { ServiceMasterService } from '../../services/service-master-service';
import { UtilityService } from 'src/app/modules/accounts-module/accounts/services/utility-service';
import { ServiceCreatePayload } from '../../models/service-create-model';
import {  ServiceMasterModel } from '../../models/service-master-model';


@Component({
  selector: 'app-service-master',
  templateUrl: './service-master.component.html',
  styleUrls: ['./service-master.component.css'],
})
export class ServiceMasterComponent implements OnInit {
  /** Form model */
  public serviceDetails: ServiceDetailModel[] = [];
  l_formDataService: ServiceMasterModel = new ServiceMasterModel();
  private l_clientId!: number;
    /** Flags */
  public isEditMode = false;

  /** Table */
  displayedColumns: string[] = [
    'srNo',
    'serviceName',
    'serviceDescription',
    'serviceDefaultSms',
    'isActive',
    'actions',
  ];

  dataSource = new MatTableDataSource<ServiceMasterModel>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private l_ServiceMasterService: ServiceMasterService,
    private l_UtilityService: UtilityService
  ) {}

  ngOnInit(): void {
    /** Defaults */
    this.l_formDataService.isActive = 'YES';

    const client = JSON.parse(sessionStorage.getItem('client_master'));
    this.l_clientId = client?.clientId;
    this.lFN_GetServiceList();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  /* ---------------------------------------------------
   * GET LIST
   * --------------------------------------------------- */
  lFN_GetServiceList(): void {
    this.l_UtilityService.lFN_ShowLoader();

    this.l_ServiceMasterService.lFN_GetServiceList().subscribe({
      next: (res: any) => {
        const parsed = JSON.parse(res.body);

        if (!parsed?.data || !Array.isArray(parsed.data)) {
          this.dataSource.data = [];
          return;
        }

        this.dataSource.data = parsed.data.map((s: any) => ({
          serviceHeaderId: s.serviceHeaderId,
          serviceName: s.serviceName,
          serviceDescription: s.serviceDesc,
          serviceDefaultSms: s.serviceDefaultSmsCount,
          isActive: s.serviceIsactive,
        }));
      },
      error: () => {
        this.l_UtilityService.lFN_ErrorToaster(
          'Failed to load services',
          'Error'
        );
      },
      complete: () => {
        this.l_UtilityService.lFN_HideLoader();
      },
    });
  }

  /* ---------------------------------------------------
   * SUBMIT (CREATE / UPDATE)
   * --------------------------------------------------- */
  async lFN_SubmitService(form: NgForm): Promise<void> {
    if (form.invalid) return;

    this.l_UtilityService.lFN_ShowLoader();

    try {
      
      if (this.l_formDataService.serviceDefaultSms < 0) {
        this.l_UtilityService.lFN_ErrorToaster(
          'Default SMS count cannot be less than 0',
          'Validation Error'
        );
        return;
      }

      const hasInvalidDays = this.serviceDetails.some(
        (d) => d.serviceSmsSendBeforeDays <= 0
      );

      if (hasInvalidDays) {
        this.l_UtilityService.lFN_ErrorToaster(
          'Send SMS Before (Days) must be greater than 0',
          'Validation Error'
        );
        return;
      }
      
      const payload = new ServiceCreatePayload({
        clientId: this.l_clientId,
        categoryId: 1,
        serviceName: this.l_formDataService.serviceName,
        serviceDesc: this.l_formDataService.serviceDescription,
        serviceDefaultSmsCount: this.l_formDataService.serviceDefaultSms,
        serviceIsactive: this.l_formDataService.isActive,
        serviceDetails: this.serviceDetails,
      });

      // 🔥 UPDATE ONLY
      if (this.isEditMode) {
        payload.serviceHeaderId = this.l_formDataService.serviceHeaderId;
      }

      await this.l_ServiceMasterService.lFN_SaveService(payload).toPromise();

      this.l_UtilityService.lFN_SuccessToaster(
        'Service saved successfully',
        'Success'
      );

      this.lFN_ResetForm(form);
      this.lFN_GetServiceList();
    } catch (err: any) {
      console.error(err);
      this.l_UtilityService.lFN_ErrorToaster(
        err?.error?.message || 'Failed to save service',
        'Error'
      );
    } finally {
      this.l_UtilityService.lFN_HideLoader();
    }
  }

  /* ---------------------------------------------------
   * EDIT
   * --------------------------------------------------- */

  lFN_EditService(service: ServiceMasterModel): void {
  if (!service?.serviceHeaderId) return;

  this.isEditMode = true;
  this.l_UtilityService.lFN_ShowLoader();

  this.l_ServiceMasterService
    .lFN_GetServiceById(service.serviceHeaderId)
    .subscribe({
      next: (res) => {
        const parsed = JSON.parse(res.body || '{}');
        const data = parsed?.data;

        if (!data) {
          this.l_UtilityService.lFN_ErrorToaster(
            'Invalid service data received',
            'Error'
          );
          return;
        }

        /** Populate form model */
        this.l_formDataService = {
          serviceHeaderId: data.serviceHeaderId,
          serviceName: data.serviceName,
          serviceDescription: data.serviceDesc,
          serviceDefaultSms: data.serviceDefaultSmsCount,
          isActive: data.serviceIsactive,
          serviceDetails: data.serviceDetails ?? [],
        };

        /** Bind service details for UI */
        this.serviceDetails = [...(data.serviceDetails ?? [])];

        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
      error: () => {
        this.l_UtilityService.lFN_ErrorToaster(
          'Failed to load service details',
          'Error'
        );
      },
      complete: () => {
        this.l_UtilityService.lFN_HideLoader();
      },
    });
}

  /* ---------------------------------------------------
   * STATUS CHANGE
   * --------------------------------------------------- */
 lFN_ChangeServiceStatus(service: ServiceMasterModel): void {

  const newStatus: 'YES' | 'NO' =
    service.isActive === 'YES' ? 'NO' : 'YES';

  const dialogData = {
    title: `Change Status - ${service.serviceName}`,
    message: `Are you sure you want to change service status to ${newStatus}?`,
    buttons: [
      { label: 'Yes', value: true, color: 'primary' },
      { label: 'No', value: false, color: 'warn' },
    ],
  };

  this.l_UtilityService
    .lFN_ShowConfirmationDialog(
      dialogData.title,
      dialogData.message,
      dialogData.buttons
    )
    .subscribe((confirmed) => {
      if (!confirmed) return;
      
      this.l_UtilityService.lFN_ShowLoader();
     
      this.l_ServiceMasterService
        .lFN_ToggleServiceStatus(service.serviceHeaderId!)
        .subscribe({
          next: () => {
            // ✅ Optimistic UI update
            service.isActive = newStatus;

            this.l_UtilityService.lFN_SuccessToaster(
              'Service status updated successfully',
              'Success'
            );
          },
          error: () => {
            this.l_UtilityService.lFN_ErrorToaster(
              'Failed to update service status',
              'Error'
            );
          },
          complete: () => {
            this.l_UtilityService.lFN_HideLoader();
          },
        });
    });
}

  /* ---------------------------------------------------
   * RESET
   * --------------------------------------------------- */
  lFN_ResetForm(form: NgForm): void {
    form.resetForm();
    this.l_formDataService = new ServiceMasterModel();
    this.l_formDataService.isActive = 'YES';
    this.isEditMode = false;
  }


  /* ---------------------------------------------------------
   * UTIL
   * --------------------------------------------------------- */

//   private lFN_GetEmptyForm(): ServiceHeaderModel {
//     return {
//       serviceName: '',
//       serviceDescription: '',
//       serviceDefaultSms: 0,
//       isActive: 'YES',
//     };
//   }

  ngDoCheck(): void {
  this.lFN_SyncDetailRows();
}

  private lFN_SyncDetailRows(): void {
  const count = this.l_formDataService.serviceDefaultSms || 0;

  if (count < 0) return;

  if (this.serviceDetails.length !== count) {
    this.serviceDetails = Array.from({ length: count }, (_, i) => ({
      serviceSmsSendBeforeDays:
        this.serviceDetails[i]?.serviceSmsSendBeforeDays ?? 0,
    }));
  }
}
}

